{
  "version": 1,
  "asset_id": "503dcf17-632a-406c-8418-f2732cec57f1",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/503dcf17-632a-406c-8418-f2732cec57f1/sleeve-amateur-2-440.png",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/503dcf17-632a-406c-8418-f2732cec57f1/sleeve-amateur-2-440.png",
  "original_filename": "sleeve-amateur-2-440.png",
  "size": 167611,
  "content_type": "image/png",
  "created_at": "2026-09-29T01:15:44Z"
}
